exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".footer{position:absolute;bottom:0;width:100%;height:60px;background-color:#f5f5f5}.footer>.container{padding-right:15px;padding-left:15px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./modules/base/css/footer.scss
// module id = 470
// module chunks = 0